import script from "./ServiceRecoveryModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceRecoveryModal.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceRecoveryModal.vue?vue&type=style&index=0&id=70fc0a6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70fc0a6e"]])

export default __exports__